"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVerifyOtpLogin = void 0;
const fetchVerifyOtpLogin = (api, progressId, body) => api.POST(`${window.MIDDLEWARE_AUTH_BASE_HOST}/authorization/otp/verify`, body, {
    headers: {
        progressId,
    },
});
exports.fetchVerifyOtpLogin = fetchVerifyOtpLogin;
//# sourceMappingURL=resolver.js.map